export const gaId = process.env.gaId

export const gaEvent = (eventName, eventLabel, eventAction, eventCategory) => {
  if (process.browser) {
    window.gtag('event', eventName, {
      event_label: eventLabel,
      event_action: eventAction,
      event_category: eventCategory,
      send_to: gaId
    })
  }
}
